export default __webpack_public_path__ + "static/media/transfer4.b6dca3eb.mp4";